import styled from 'styled-components'

export const Card = styled.div`
    background-color: ${({theme}) => theme.colors.background.default};
    border: 1px solid ${({theme}) => theme.colors.border.default};
    border-radius: ${({theme}) => theme.radii.arc20};
    box-shadow: 0 6px 24px 0 rgb(0 0 0 / 10%);
`
